import React from 'react';
import * as aTypes from 'Flow2/components/AdvancedBox/AdvancedConfig/AdvancedTypes';
import "./CheckBox.scss";

const CheckBox = ({ onCbHandler, isChecked, label }) => {
    let length = aTypes.CHECKBOX_LEN;
    return (
        <div className="advanced-checkbox">
            <div className="advanced-wrapper" onClick={onCbHandler}>
                <span className="advanced-box" />
                <div className="advanced-svg">
                    <svg viewBox="0 0 100 100" style={{ height: 16, width: 16 }} xmlns="http://www.w3.org/2000/svg" >
                        <path
                            stroke='white'
                            strokeWidth="12"
                            fill="none"
                            d='M16.667,62.167c3.109,5.55,7.217,10.591,10.926,15.75 c2.614,3.636,5.149,7.519,8.161,10.853c-0.046-0.051,1.959,2.414,2.692,2.343c0.895-0.088,6.958-8.511,6.014-7.3 c5.997-7.695,11.68-15.463,16.931-23.696c6.393-10.025,12.235-20.373,18.104-30.707C82.004,24.988,84.802,20.601,87,16'
                            strokeDashoffset={isChecked ? 0 : length}
                            style={{ strokeLinecap: 'round', strokeLinejoin: 'round', transition: 'stroke-dashoffset 0.2s ease-in-out', strokeDasharray: `${length} ${length}` }}
                        />
                    </svg>
                </div>
                {label && <span className="advanced-label">{label}</span>}
            </div>
        </div>
    )
}

export default CheckBox;